import Radio from 'backbone.radio';
import ProductSettingsDialog from '@/views/dialogs/product_settings';

    var globalCh = Radio.channel('global');

    export default function show_product_settings_dialog(options){
        var view = new ProductSettingsDialog(options);

        globalCh.request('showDialog', view);
    }

